import {useScreenRotation} from "@utils/useScreenRotation";

export const useSidebarNavProp = () => {
    const isRotated = useScreenRotation();

    return {
        isRotated
    }
};
